"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PersonalDetailsForm = void 0;
var _zod = require("@hookform/resolvers/zod");
var _components = require("@ori-ui/components");
var _mui = require("@ori-ui/mui");
var _commonFormFields = require("@ori/common-form-fields");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _reactHookForm = require("react-hook-form");
var _Localization = require("../../../Localization");
var _defaultTranslations_simplifiedRegistrationBrandPartner = require("../../../constants/defaultTranslations_simplified-registration-BrandPartner");
var _contexts = require("../../../contexts");
var _useTranslations_simplifiedRegistrationBrandPartner = require("../../../hooks/useTranslations_simplified-registration-BrandPartner");
var _models = require("../../../models");
var _FormValidationSummary = require("../../FormValidationSummary");
var _AddressSection = require("./AddressSection");
var _validationSchema = require("./validationSchema");
var _jsxRuntime = require("react/jsx-runtime");
const StyledForm = (0, _mui.styled)('form')(({
  theme
}) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: '100%',
  marginTop: theme.spacing(8)
}));
const SubmitButtton = (0, _mui.styled)(_components.Button)(({
  theme
}) => ({
  minWidth: '330px',
  marginTop: theme.spacing(3),
  order: 20
}));
const PersonalDetailsForm = props => {
  const {
    initialData,
    config,
    isSuccessSubmit,
    onSubmitForm
  } = props;
  const {
    formatMessage
  } = (0, _useTranslations_simplifiedRegistrationBrandPartner.useTranslations)();
  const {
    customerServiceUrl
  } = (0, _contexts.useConfiguration)();
  const {
    getTestIdProps
  } = (0, _testidGenerator.default)();
  const datePickerPlaceholder = formatMessage(_models.TranslationKey.FirstStep_PlaceHolder);
  const validationSchema = (0, _validationSchema.useGetSchema)(config);
  const methods = (0, _reactHookForm.useForm)({
    defaultValues: initialData,
    reValidateMode: 'onChange',
    mode: 'all',
    resolver: (0, _zod.zodResolver)(validationSchema)
  });
  const {
    formState,
    watch
  } = methods;
  const {
    isSubmitting,
    isValid
  } = formState;
  const formValues = watch();
  const {
    errorData
  } = (0, _contexts.useFormError)();
  const {
    customErrors
  } = errorData;
  const invalidCodeErrors = customErrors?.filter(er => !Object.keys(formValues).map(val => val.toLowerCase()).includes(er.fieldName?.toLowerCase() ?? ''));
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactHookForm.FormProvider, {
    ...methods,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_FormValidationSummary.FormValidationSummary, {
      invalidPropertyErrors: invalidCodeErrors,
      customerServiceUrl: customerServiceUrl
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledForm, {
      noValidate: true,
      onSubmit: methods.handleSubmit(onSubmitForm),
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_mui.Grid, {
        container: true,
        justifyContent: "center",
        order: 1,
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_commonFormFields.TextFormFieldByConfig, {
          name: "firstName",
          label: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
            id: _models.TranslationKey.FirstStep_FirstName,
            defaultMessage: _defaultTranslations_simplifiedRegistrationBrandPartner.defaultTranslations.FirstStep_FirstName
          }),
          ...config?.firstName,
          useUpperCase: config?.useUpperCase?.isEnabled,
          isMandatory: config?.firstName?.validation?.isMandatory,
          maxLengthLimit: config?.firstName?.validation?.maxLength,
          customErrors: customErrors
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_commonFormFields.TextFormFieldByConfig, {
          enableLowercaseLetters: true,
          name: "contactEmail",
          label: config?.contactEmail?.validation?.isMandatory ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
            id: _models.TranslationKey.FirstStep_Email,
            defaultMessage: _defaultTranslations_simplifiedRegistrationBrandPartner.defaultTranslations.FirstStep_Email
          }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
            id: _models.TranslationKey.FirstStep_Email_Optional,
            defaultMessage: _defaultTranslations_simplifiedRegistrationBrandPartner.defaultTranslations.FirstStep_Email_Optional
          }),
          customPlaceholder: formatMessage(_models.TranslationKey.FirstStep_PlaceholderEmail),
          keyboardType: "email",
          ...config?.contactEmail,
          isMandatory: config?.contactEmail?.validation?.isMandatory,
          maxLengthLimit: config?.contactEmail?.validation?.maxLength,
          customErrors: customErrors
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_commonFormFields.PhoneFieldByConfig, {
          name: "contactTelephone",
          label: config?.contactTelephone?.validation?.isMandatory ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
            id: _models.TranslationKey.FirstStep_Phone,
            defaultMessage: _defaultTranslations_simplifiedRegistrationBrandPartner.defaultTranslations.FirstStep_Phone
          }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
            id: _models.TranslationKey.FirstStep_Phone_Optional,
            defaultMessage: _defaultTranslations_simplifiedRegistrationBrandPartner.defaultTranslations.FirstStep_Phone_Optional
          }),
          labelWithPrefix: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
            id: _models.TranslationKey.FirstStep_PhoneWithPrefix,
            defaultMessage: _defaultTranslations_simplifiedRegistrationBrandPartner.defaultTranslations.FirstStep_PhoneWithPrefix
          }),
          helperText: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
            id: _models.TranslationKey.FirstStep_TooltipPhone,
            defaultMessage: _defaultTranslations_simplifiedRegistrationBrandPartner.defaultTranslations.FirstStep_TooltipPhone
          }),
          helperTextWithPrefix: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
            id: _models.TranslationKey.FirstStep_TooltipPhoneWithPrefix,
            defaultMessage: _defaultTranslations_simplifiedRegistrationBrandPartner.defaultTranslations.FirstStep_TooltipPhoneWithPrefix
          }),
          customPlaceholder: formatMessage(_models.TranslationKey.FirstStep_PlaceholderPhone),
          customPlaceholderWithPrefix: formatMessage(_models.TranslationKey.FirstStep_PlaceholderPhoneWithPrefix),
          initialValue: formValues.contactTelephone,
          ...config?.contactTelephone,
          isMandatory: config?.contactTelephone?.validation?.isMandatory,
          maxLengthLimit: config?.contactTelephone?.validation?.maxLength,
          customErrors: customErrors
        }), config?.address?.operations?.read?.isEnabled ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_AddressSection.AddressSection, {
          configAddress: config.address,
          actualValues: formValues.address,
          useUpperCaseAddress: config.useUpperCase?.isEnabled
        }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_commonFormFields.SelectFormFieldByConfig, {
          name: "address.country",
          label: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
            id: _models.TranslationKey.FirstStep_Country,
            defaultMessage: _defaultTranslations_simplifiedRegistrationBrandPartner.defaultTranslations.FirstStep_Country
          }),
          placeholder: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
            id: _models.TranslationKey.FirstStep_Country_Placeholder,
            defaultMessage: _defaultTranslations_simplifiedRegistrationBrandPartner.defaultTranslations.FirstStep_Country_Placeholder
          }),
          helperText: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
            id: _models.TranslationKey.FirstStep_Country_Tooltip,
            defaultMessage: _defaultTranslations_simplifiedRegistrationBrandPartner.defaultTranslations.FirstStep_Country_Tooltip
          }),
          ...config?.address?.country,
          isMandatory: config?.address?.country?.validation?.isMandatory
        }, formValues.address?.country), /*#__PURE__*/(0, _jsxRuntime.jsx)(_commonFormFields.TextFormFieldByConfig, {
          name: "lastName",
          label: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
            id: _models.TranslationKey.FirstStep_LastName,
            defaultMessage: _defaultTranslations_simplifiedRegistrationBrandPartner.defaultTranslations.FirstStep_LastName
          }),
          ...config?.lastName,
          useUpperCase: config?.useUpperCase?.isEnabled,
          isMandatory: config?.lastName?.validation?.isMandatory,
          maxLengthLimit: config?.lastName?.validation?.maxLength,
          customErrors: customErrors
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_commonFormFields.TextFormFieldByConfig, {
          name: "uniqueId",
          label: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
            id: _models.TranslationKey.FirstStep_UniqueId,
            defaultMessage: _defaultTranslations_simplifiedRegistrationBrandPartner.defaultTranslations.FirstStep_UniqueId
          }),
          helperText: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
            id: _models.TranslationKey.FirstStep_UniqueId_Tooltip,
            defaultMessage: _defaultTranslations_simplifiedRegistrationBrandPartner.defaultTranslations.FirstStep_UniqueId_Tooltip
          }),
          ...config?.uniqueId,
          isMandatory: config?.uniqueId?.validation?.isMandatory,
          maxLengthLimit: config?.uniqueId?.validation?.maxLength,
          customErrors: customErrors
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_commonFormFields.SelectFormFieldByConfig, {
          name: "gender",
          label: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
            id: _models.TranslationKey.FirstStep_Gender,
            defaultMessage: _defaultTranslations_simplifiedRegistrationBrandPartner.defaultTranslations.FirstStep_Gender
          }),
          labelMapper: _Localization.GenderLabelMapper,
          placeholder: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
            id: _models.TranslationKey.FirstStep_Gender_Placeholder,
            defaultMessage: _defaultTranslations_simplifiedRegistrationBrandPartner.defaultTranslations.FirstStep_Gender_Placeholder
          }),
          ...config?.gender,
          isMandatory: config?.gender?.validation?.isMandatory,
          customErrors: customErrors
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_commonFormFields.DatePickerField, {
          name: "birthDate",
          label: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
            id: _models.TranslationKey.FirstStep_DateOfBirth,
            defaultMessage: _defaultTranslations_simplifiedRegistrationBrandPartner.defaultTranslations.FirstStep_DateOfBirth
          }),
          infoText: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
            id: _models.TranslationKey.FirstStep_DateOfBirthText,
            defaultMessage: _defaultTranslations_simplifiedRegistrationBrandPartner.defaultTranslations.FirstStep_DateOfBirthText
          }),
          placeholderText: datePickerPlaceholder,
          ...config?.birthDate,
          isMandatory: config?.birthDate?.validation?.isMandatory,
          minDate: config?.birthDate?.validation?.minValue,
          maxDate: config?.birthDate?.validation?.maxValue,
          customErrors: customErrors
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(SubmitButtton, {
          variant: "contained",
          color: "primary",
          type: "submit",
          disabled: !isValid || isSubmitting || isSuccessSubmit,
          ...getTestIdProps('submit-btn-personalForm'),
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
            id: _models.TranslationKey.FirstStep_Button,
            defaultMessage: _defaultTranslations_simplifiedRegistrationBrandPartner.defaultTranslations.FirstStep_Button
          })
        })]
      })
    })]
  });
};
exports.PersonalDetailsForm = PersonalDetailsForm;